import React from "react";
import styles from "./PlaydateInviteCreationView.module.css";
import Layout from "../../layout/Layout";
import ActionButton from "../../button/ActionButton";
import { InviteStatus, PlaydateInvite } from "../../../gql/types";
import PlaydateInvitationCard from "../PlaydateInvitationCard";

export interface PlaydateInviteCreationCompletionViewProps {
    baseZIndex?: number;
    invite: PlaydateInvite;
    onShare?: (invite: PlaydateInvite) => void;
    onBack: () => void;
}

const PlaydateInviteCreationCompletionView: React.FC<PlaydateInviteCreationCompletionViewProps> = ({
    baseZIndex,
    invite,
    onShare,
    onBack,
}) => {
    return (
        <Layout
            navbarConfig={{
                title: "Invite Created",
                onBack: onBack,
            }}
            containerConfig={{
                removeTopPadding: true,
            }}
            baseZIndex={baseZIndex ? baseZIndex + 1 : 1}
        >
            <div className={styles.editorContainer}>
                <div className={styles.infoSection}>
                    {(invite.guests && invite.guests.length > 0) && (
                        <span> Great! Your invite has been successfully created and shared with your connections. </span>
                    )}
                    {(!(invite.guests) || invite.guests.length == 0) && (
                        <span> Great! Your invite has been successfully created. </span>
                    )}
                    <span> You can review the details and responses in your </span><span className={styles.underline}>outbox</span>.
                </div>
                <div className={styles.contentDivider} />
                <PlaydateInvitationCard invite={invite} onBack={onBack} baseZIndex={baseZIndex} />
                <div className={styles.shareEncouragement}>
                    {onShare && <span>Your friend isn’t on Plii yet? <br></br>
                        Share the invite with them externally!
                    </span>}
                </div>
                <div className={styles.buttonContainer}>
                    {onShare && <ActionButton
                        onClick={() => onShare(invite)}
                        disabled={invite.status == InviteStatus.Abandoned}
                    >
                        Share Externally
                    </ActionButton>
                    }
                    <ActionButton colorPattern={
                        onShare && invite.status != InviteStatus.Abandoned ?
                            "Transparent" : "Default"} onClick={onBack}>
                        Back
                    </ActionButton>
                </div>
            </div>
        </Layout >
    );
};

export default PlaydateInviteCreationCompletionView;
